// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class DataSort extends WebComponent {
	didMount() {
		const sortHandlers = document.querySelectorAll('#pageFilters .acs-desc-wrap span');
        const orderBy = document.getElementById('orderColumn');
        const orderType = document.getElementById('order');

		// Set inputs
        const setParams = function(type, by) {
            let event = new Event('change', { bubbles: true });
			orderType.value = type;
            orderType.dispatchEvent(event);
			orderBy.value = by;
            orderBy.dispatchEvent(event);
		};

        // Set table header
		document.querySelector('.acs-desc-wrap [data-order-by="'+orderBy.value+'"].'+orderType.value).classList.add('select');
		/*let activeColumn = document.querySelectorAll('.table__body-'+orderBy.value);
        for (let i = 0; i < activeColumn.length; i++) {
            activeColumn[i].classList.add('active');
        }*/

		// Bind click event
		for (let i = 0; i < sortHandlers.length; i++) {
            sortHandlers[i].addEventListener('click', function(event) {
                setParams(this.dataset.orderType, this.dataset.orderBy);
            });
            sortHandlers[i].addEventListener('keydown', function(event) {
                if ((event.which || event.keyCode) === 13) {
                    setParams(this.dataset.orderType, this.dataset.orderBy);
                }
            });
        }
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/DataSort.js